import { PayloadAction } from '@reduxjs/toolkit';
import { CurrencyTypes } from '../../core/enums/CurrencyTypes';

export const CountryCoverageLimitsReducer = {
	setCountryCoverageLimits: (
		state: { currency: CurrencyTypes },
		action: PayloadAction<CurrencyTypes>
	) => {
		state.currency = action.payload;
	},
};
